export default "__VITE_ASSET__JZ04__VE__"